export default "__VITE_ASSET__BCTO_dbE__"